export const CardActionType = {
    SEND_PROPOSAL_CARD_BENEFIT: 'card/SEND_PROPOSAL_CARD_BENEFIT',
    SEND_PROPOSAL_CARD_BMG: 'card/SEND_PROPOSAL_CARD_BMG',
    SEND_PROPOSAL_CARD_MASTER: 'card/SEND_PROPOSAL_CARD_MASTER',
}